import Vue from 'vue'
import store from '@/store'
import Router from 'vue-router'
import { constantRouterMap } from '@/config/router.config'
import { ACCESS_TOKEN,USER_INFO,USER_ROLE,TENANT_CONFIG } from "@/store/mutation-types";
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getAction } from "@/api/manage";
NProgress.configure({ showSpinner: false }) // NProgress Configuration


Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})

// store.dispatch('ThemeRouter').then(() => {
//   // 动态添加主题路由表
//   let tenantConfig = Vue.ls.get(TENANT_CONFIG);
//   let themeRouterMap = require(`@/theme/${tenantConfig.theme}/router.config.js`)

//   console.log(themeRouterMap);
//   router.addRoutes(themeRouterMap.default)
// })

let flag = true

router.beforeEach((to, from, next) => {
  store.commit('SET_PAGE_LOGADING',true)
  if (flag) {

  //HOJ token登录
  if(to.query.hojtoken){ 
    getAction("/thirdLogin/hoj/getUserInfo?token=" + to.query.hojtoken).then(tokenRes=>{
      if(tokenRes.success){
        getAction("/thirdLogin/getLoginUser/" + tokenRes.result).then(res=>{
          if(res.success){
            let token = res.result.token
            let userInfo = res.result.userInfo
            const expire = 7 * 24 * 60 * 60 * 1000
            Vue.ls.set(ACCESS_TOKEN, token, expire)
            store.commit('SET_TOKEN', token)
            Vue.ls.set(USER_INFO, userInfo, expire)
            store.commit('SET_USER_INFO', userInfo)
            store.commit('SET_NAME', { username: userInfo.username, realname: userInfo.realname })
            store.commit('SET_AVATAR', userInfo.avatar)
            changeURLStatic("hojtoken", "")
            window.location.reload()
          }else{
            alert("登录失败")
          }
        })
      }else{
        alert("登录失败,Token无效")
      }
    })
  }
  if(window.location.hash == '#auth-qrcode'){
    getAction('/thirdLogin/wechat/getUserInfo').then(res=>{
      if(res.success){
        // getAction("/thirdLogin/getLoginUser/" + res.result.token).then(res=>{
        //   if(res.success){
        //     let token = res.result.token
        //     let userInfo = res.result.userInfo
        //     const expire = 7 * 24 * 60 * 60 * 1000
        //     Vue.ls.set(ACCESS_TOKEN, token, expire)
        //     store.commit('SET_TOKEN', token)
        //     Vue.ls.set(USER_INFO, userInfo, expire)
        //     store.commit('SET_USER_INFO', userInfo)
        //     store.commit('SET_NAME', { username: userInfo.username, realname: userInfo.realname })
        //     store.commit('SET_AVATAR', userInfo.avatar)
        //     // changeURLStatic("hojtoken", "")
        //     // window.location.reload()
        //     window.location.href = "/"
        //   }else{
        //     alert("登录失败")
        //   }
        let token = res.result.token
        let userInfo = res.result.userInfo
        const expire = 7 * 24 * 60 * 60 * 1000
        Vue.ls.set(ACCESS_TOKEN, token, expire)
        store.commit('SET_TOKEN', token)
        Vue.ls.set(USER_INFO, userInfo, expire)
        store.commit('SET_USER_INFO', userInfo)
        store.commit('SET_NAME', { username: userInfo.username, realname: userInfo.realname })
        store.commit('SET_AVATAR', userInfo.avatar)
        window.location.href = "/"
      }else{
        alert('登录失败')
      }
    })
  }

    NProgress.start() // start progress bar
    //加载权限
    if (Vue.ls.get(ACCESS_TOKEN)) {
      if (store.getters.permissionList.length === 0) {
        store.dispatch('GetPermissionList').then(res => {
              const menuData = res.result.menu;
        });
      }
    }
    //加载主题路由
    let tenantConfig = Vue.ls.get(TENANT_CONFIG);
    tenantConfig.theme = 'wayi'
    console.log("load theme router:" + tenantConfig.theme);
    let themeRouterMap = require(`@/theme/${tenantConfig.theme}/router.config.js`)
    store.dispatch('ThemeRouter', themeRouterMap).then(() => {
      // 动态添加主题路由表
      router.addRoutes(store.getters.addRouters)
      store.dispatch('clearThemeRouter')
      const redirect = decodeURIComponent(from.query.redirect || to.path)
      if (to.path === redirect) {
        // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
        let timer = setTimeout(()=>{
          next({ ...to, replace: true })
          clearTimeout(timer)
        },800)
      } else {
        // 跳转到目的路由
        let timer = setTimeout(()=>{
          next({ path: redirect })
          clearTimeout(timer)
        },800)
      }
    })
    flag = false
  } else {
    let timer = setTimeout(()=>{
      next()
      clearTimeout(timer)
    },800)
  }
})


router.afterEach(() => {
  store.commit('SET_PAGE_LOGADING',false)
  NProgress.done() // finish progress bar
})


export default router